<mat-toolbar class="site-page-header" 
  [ngClass]="{'topBarSticky': (show$ | async) !== showEnum.REPORT_TYPES}">
  <h1>
    {{ title$ | async }}
  </h1>
</mat-toolbar>
<app-breadcrumb></app-breadcrumb>
<div class="layout-container" 
  [ngClass]="{'top-padding': (show$ | async) !== showEnum.REPORT_TYPES}">
  <router-outlet></router-outlet>
</div>
